"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TokenRenderer_1 = __importDefault(require("ContentTokens/TokenRenderer"));
exports.default = (function (descriptionObject) {
    if (Array.isArray(descriptionObject.tokens) && descriptionObject.tokens.length > 0) {
        return (0, TokenRenderer_1.default)(descriptionObject.tokens);
    }
    else {
        return descriptionObject.content;
    }
});
